import React, { ReactNode } from 'react';
import CustomButton from './CustomButton';

interface DialogProps {
    isOpen: boolean,
    setIsOpen: Function,
    btnText: string,
    children: ReactNode;
    isTitle?: boolean;
    width?: string
}

const Dialog = ({ isOpen, setIsOpen, btnText, children, isTitle = true, width }: DialogProps) => {
    return (
        <div className="relative" onClick={() => setIsOpen(false)}>
            {/* Dialog Overlay */}
            {isOpen && (
                <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-60 px-4">
                    {/* Dialog Content */}
                    <div className={`bg-base rounded-lg shadow-lg ${width ? width : 'w-[500px]'} p-6 max-h-[70vh] overflow-auto`}>
                        {
                            isTitle &&
                            <h2 className="mb-4 font-semibold text-black text-xl">PulseOnShip 내용:</h2>
                        }
                        {children}
                        <div className="flex justify-end mt-6">
                            <CustomButton title={btnText} onClick={() => setIsOpen(false)} className={'!min-w-0 !w-[140px] !text-base  bg-primary'} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dialog;